import React from 'react'
import withClientSuspense from '@helpers/misc/withClientSuspense'
import useWidth from '@hooks/useWidth'
import Container from '@packages/justo-parts/lib/components/Container'
import classnames from 'classnames'

import Map from './Map'
import Store from './Store'
import Top from './Top'
import useStoreLocator from './useStoreLocator.main'

import styles from './styles.module.css'

function StoreLocator({title, icon, color, storeIds}) {
  const data = useStoreLocator()
  const {map, selectedStore, setSelectedStore, place, placeId, setPlaceId} = data
  const stores = data.stores.filter(store => storeIds.includes(store._id))
  const width = useWidth()
  const isMobile = width < 768

  return (
    <div className={styles.container}>
      <Container>
        <div className={styles.inner}>
          <div className={styles.sectionContainer}>
            {isMobile ? <Top title={title} placeId={placeId} setPlaceId={setPlaceId} /> : null}
            <Map
              map={map}
              stores={stores}
              icon={icon}
              selectedStore={selectedStore}
              color={color}
              homeLocation={place?.location}
            />
          </div>
          <div className={classnames(styles.sectionContainer, isMobile ? null : styles.overflow)}>
            {isMobile ? null : <Top title={title} placeId={placeId} setPlaceId={setPlaceId} />}
            <div className="space-y-5">
              {stores.map((store, idx) => (
                <Store
                  key={idx}
                  store={store}
                  selected={selectedStore?._id === store._id}
                  selectStore={() => setSelectedStore(store)}
                />
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default withClientSuspense(StoreLocator)
